var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._g({staticClass:"ui-icon-base component"},_vm.$listeners),[_c(_vm.iconName,{tag:"component",attrs:{"width":_vm.width,"height":_vm.height,"color":_vm.color}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }